import React from 'react'
import { Accordion } from '@shared/components/accordion'
import { Section } from '@shared/components/section'

import { IOwnProps } from './model'

import styles from './style.module.scss'

export const View = ({ accordionElements, sectionProps }: IOwnProps) => (
	<Section className={styles.wrap} {...sectionProps}>
		<h2 className={styles.title}>Ответы на вопросы</h2>
		<div className={styles.content}>
			{accordionElements.map(({ title, content: Content }, i) => (
				<Accordion key={`${title?.toString()}_${i}`} title={title}>
					{typeof Content === 'function' ? <Content /> : Content}
				</Accordion>
			))}
		</div>
	</Section>
)
